import { lazy } from 'react';

/**
 * Single place the Blocks tab's module is chosen.
 *
 * TabContent used to `import('pages/ModelOverviewPage/blocksv2')` directly,
 * which made the whole header depend on the blocksv2 module existing — so the
 * header couldn't ship on a branch that didn't also carry blocksv2 (the build
 * fails with "module not found" even though nothing renders it).
 *
 * Isolating the choice here keeps that dependency to one line: a branch that
 * has blocksv2 points this at it, a branch that doesn't leaves it on blockv1,
 * and TabContent never changes either way.
 */
// eslint-disable-next-line import/prefer-default-export
export const BlocksTabModule: any = lazy(() => import('pages/ModelOverviewPage/blockv1'));
